import { render, staticRenderFns } from "./SkeletonComparisonTable.vue?vue&type=template&id=24078f09&"
import script from "./SkeletonComparisonTable.vue?vue&type=script&lang=js&"
export * from "./SkeletonComparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports